import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";

import { TradeButton } from "../../../TradeButton/TradeButton";
import { BookAndTrades } from "./components/BookAndTrades/BookAndTrades";
import { Hedge } from "./components/Hedge/Hedge";
import { OptionSummary } from "./components/OptionSummary/OptionSummary";
import { OptionTradeDetails } from "./components/OptionTradeDetails/OptionTradeDetails";
import { PortfolioImpactAndGreeks } from "./components/PortfolioImpactAndGreeks/PortfolioImpactAndGreeks";

export const SelectedOption: React.FC = () => {
  const { isMarket } = useOptionTradeType();
  return (
    <div className="flex h-full flex-col">
      <OptionSummary />
      <OptionTradeDetails />
      {isMarket && <Hedge />}
      <PortfolioImpactAndGreeks />
      <TradeButton />
      <BookAndTrades className="mt-4 mb-1" />
    </div>
  );
};
